import { render, staticRenderFns } from "./GroupCategoryView.vue?vue&type=template&id=7d313e66"
import script from "./GroupCategoryView.vue?vue&type=script&lang=js"
export * from "./GroupCategoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports